module.exports = __webpack_public_path__ + "img/linkus-xg.aeb297db.png";